<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="container">
					<div class="mb-3">
						<ng-select
							id="type"
							name="type"
							[(ngModel)]="filters.product_kind__id__in"
							[multiple]="true"
							placeholder="Typ"
							><ng-option [value]="item.id" *ngFor="let item of type"
								>{{ item.name }}
							</ng-option></ng-select
						>
					</div>
					<div class="mb-3">
						<ng-select
							id="tags"
							name="tags"
							[(ngModel)]="filters.tags__id__in"
							[multiple]="true"
							placeholder="Tagi"
							><ng-option [value]="item.id" *ngFor="let item of allTags"
								>{{ item.name }}
							</ng-option></ng-select
						>
					</div>
					<div class="mb-3">
						<ng-select
							id="location"
							name="location"
							[(ngModel)]="filters.location__id__in"
							[multiple]="true"
							placeholder="Lokalizacja"
							><ng-option [value]="item.id" *ngFor="let item of location"
								>{{ item.name }}
							</ng-option></ng-select
						>
					</div>
					<div class="mb-3">
						<ng-select
							id="status"
							name="status"
							[(ngModel)]="filters.status__in"
							[multiple]="true"
							placeholder="Status"
							><ng-option [value]="item.value" *ngFor="let item of statusSet"
								>{{ item.name }}
							</ng-option></ng-select
						>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="row row-full">
					<div class="row">
						<div class="col-sm-7 text-start">
							<button mat-raised-button color="basic" type="button" class="me-2" (click)="filtersClear()">
								Wyczyść
							</button>
							<button mat-raised-button color="accent" type="button" (click)="filtersDefault()">
								Domyślne
							</button>
						</div>
						<div class="col-sm-5 text-end">
							<button
								mat-raised-button
								color="primary"
								type="button"
								class="me-2"
								(click)="filtersSave()"
							>
								Pokaż
							</button>
							<button
								mat-raised-button
								color="warn"
								type="button"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
